// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3kUEH","selects":"Documents_selects__1J0jI"};